module.exports = __webpack_public_path__ + "static/media/Vayne.5d5af670.png";